import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';

import { SearchTrigger } from '../search/search-trigger';
import { clearSearch } from '../../tools/functions';

export const HeaderCatalogMenu = {
    components: {
        SearchTrigger
    },
    data() {
        return {
          pointerHistory: [],
          tabSwitchTimer: null,
          pendingTabLink: null,
          catalogColumnCount: window.innerWidth < 1366 ? 2 : 3,
          catalogLayoutFrame: null,
          catalogOpenObserver: null,
          catalogIsDesktop: window.innerWidth > 991,
          catalogIsPortrait: window.matchMedia('(orientation: portrait)').matches
        };
    },
    mounted() {
        this.$el.addEventListener('mousemove', this.trackCatalogPointer, {passive: true});
        window.addEventListener('resize', this.handleCatalogResize, {passive: true});

        this.catalogOpenObserver = new MutationObserver(() => {
          if (this.$el.classList.contains('is-open')) {
            this.$nextTick(() => {
              this.scheduleCatalogLayout();
            });
          }
        });

        this.catalogOpenObserver.observe(this.$el, {
          attributes: true,
          attributeFilter: ['class']
        });
    },
    beforeUnmount() {
        this.cancelTabSwitch();

        this.$el.removeEventListener('mousemove', this.trackCatalogPointer);
        window.removeEventListener('resize', this.handleCatalogResize);

        if (this.catalogOpenObserver) {
          this.catalogOpenObserver.disconnect();
          this.catalogOpenObserver = null;
        }

        if (this.catalogLayoutFrame) {
          window.cancelAnimationFrame(this.catalogLayoutFrame);
          this.catalogLayoutFrame = null;
        }
    },
    computed: {
        ...mapState(vplSiteStore, ['menu', 'SITE_TEMPLATE_PATH'])
    },
    methods: {
        trackCatalogPointer(event){
          if ($(window).width() <= 991) {
            return;
          }

          const now = Date.now();
          const lastPoint = this.pointerHistory[this.pointerHistory.length - 1];
          const hasMoved = !lastPoint ||
            Math.abs(event.clientX - lastPoint.x) + Math.abs(event.clientY - lastPoint.y) >= 2;

          if (hasMoved && (!lastPoint || now - lastPoint.time >= 40)) {
            this.pointerHistory.push({
              x: event.clientX,
              y: event.clientY,
              time: now
            });
            this.pointerHistory = this.pointerHistory.filter(point => now - point.time <= 300);

            if (this.pendingTabLink && $(this.pendingTabLink).is(':hover')) {
              this.scheduleTabSwitch(this.pendingTabLink);
            }
          }
        },
        closeMenu() {
            this.cancelTabSwitch();
            this.pointerHistory = [];
            clearSearch();
            $('.js-catalog').removeClass('is-active');
            $('.js-header').find('.js-catalog-dropdown').removeClass('is-open');
            $('body').removeClass('dropdown-open');
        },
        changeTab(id){
          this.cancelTabSwitch();

          if ($(window).width() > 991) {
            $(this.$el).find('.js-header-catalog-nav.is-active').removeClass('is-active');
            $(this.$el).find('.js-header-catalog-nav[data-nav="' + id + '"]').addClass('is-active');
            $(this.$el).find('.js-header-catalog-content.is-active').removeClass('is-active');
            $(this.$el).find('.js-tab-nav.is-active').removeClass('is-active');
            $(this.$el).find('.js-tab-content.is-active').removeClass('is-active');

            const catalogContent = $(this.$el).find('.js-header-catalog-content[data-nav="' + id + '"]').addClass('is-active');
            catalogContent.find('.js-tab-nav').first().addClass('is-active');
            catalogContent.find('.js-tab-content').first().addClass('is-active');

          } else {
            $(this.$el).find('.js-header-catalog-nav.is-active').removeClass('is-active');
            $(this.$el).find('.js-header-catalog-content.is-active').removeClass('is-active');
          }

          this.$nextTick(() => {
            this.scheduleCatalogLayout();
          });
        },
        tabMouseEnter(event){
          const link = event.currentTarget;
          const id = link.getAttribute('data-tab');

          if ($(window).width() > 991) {
            this.cancelTabSwitch();

            if (link.classList.contains('is-active')) {
              return;
            }

            if (this.isMovingTowardSubmenu(event)) {
              this.scheduleTabSwitch(link);
            } else {
              this.activateTab(link, id);
            }
          } else {
            $(this.$el).find('.js-tab-nav.is-active').removeClass('is-active');
            $(this.$el).find('.js-tab-content.is-active').removeClass('is-active');
          }
        },
        activateTab(link, id){
          const catalogContent = $(link).closest('.js-header-catalog-content');

          catalogContent.find('.js-tab-nav.is-active').removeClass('is-active');
          $(link).addClass('is-active');
          catalogContent.find('.js-tab-content.is-active').removeClass('is-active');
          catalogContent.find('.js-tab-content[data-tab="' + id + '"]').addClass('is-active');

          this.$nextTick(() => {
            this.scheduleCatalogLayout();
          });
        },
        scheduleTabSwitch(link){
          if (this.tabSwitchTimer) {
            window.clearTimeout(this.tabSwitchTimer);
          }

          this.pendingTabLink = link;
          this.tabSwitchTimer = window.setTimeout(() => {
            const pendingLink = this.pendingTabLink;
            this.tabSwitchTimer = null;
            this.pendingTabLink = null;

            if (pendingLink && $(pendingLink).is(':hover')) {
              this.activateTab(pendingLink, pendingLink.getAttribute('data-tab'));
            }
          }, 600);
        },
        cancelTabSwitch(){
          if (this.tabSwitchTimer) {
            window.clearTimeout(this.tabSwitchTimer);
          }

          this.tabSwitchTimer = null;
          this.pendingTabLink = null;
        },
        isMovingTowardSubmenu(event){
          const catalogContent = $(event.currentTarget).closest('.js-header-catalog-content');
          const submenu = catalogContent.find('.js-header-catalog-submenu').get(0);
          const content = catalogContent.get(0);

          if (!submenu || !content || !this.pointerHistory.length) {
            return false;
          }

          const now = Date.now();
          const currentPoint = {
            x: event.clientX,
            y: event.clientY
          };
          const recentPoints = this.pointerHistory.filter(point =>
            now - point.time <= 300
          );
          const lastPoint = recentPoints[recentPoints.length - 1];
          const previousPoint = recentPoints.find(point =>
            currentPoint.x - point.x >= 4 &&
            now - point.time >= 40
          );

          if (!previousPoint) {
            return false;
          }

          const submenuRect = submenu.getBoundingClientRect();
          const contentRect = content.getBoundingClientRect();

          if (
            currentPoint.x >= submenuRect.left ||
            currentPoint.x <= previousPoint.x ||
            (lastPoint && currentPoint.x < lastPoint.x - 2)
          ) {
            return false;
          }

          const projectedY = currentPoint.y +
            ((currentPoint.y - previousPoint.y) / (currentPoint.x - previousPoint.x)) *
            (submenuRect.left - currentPoint.x);

          const aimTop = Math.min(submenuRect.top, contentRect.top) - 24;
          const aimBottom = Math.max(submenuRect.bottom, contentRect.bottom) + 24;

          return projectedY >= aimTop && projectedY <= aimBottom;
        },
        handleCatalogResize(){
          const isDesktop = window.innerWidth > 991;
          const isPortrait = window.matchMedia('(orientation: portrait)').matches;
          const viewportModeChanged = isDesktop !== this.catalogIsDesktop;
          const orientationChanged = isPortrait !== this.catalogIsPortrait;

          this.catalogIsDesktop = isDesktop;
          this.catalogIsPortrait = isPortrait;
          this.catalogColumnCount = window.innerWidth < 1366 ? 2 : 3;

          if (
            (viewportModeChanged || orientationChanged) &&
            this.$el.classList.contains('is-open')
          ) {
            clearSearch();
            this.closeMenu();
            return;
          }

          this.$nextTick(() => {
            this.scheduleCatalogLayout();
          });
        },
        scheduleCatalogLayout(){
          if (this.catalogLayoutFrame) {
            window.cancelAnimationFrame(this.catalogLayoutFrame);
          }

          this.catalogLayoutFrame = window.requestAnimationFrame(() => {
            this.catalogLayoutFrame = null;
            this.updateCatalogLayout();
          });
        },
        updateCatalogLayout(){
          const dropdown = this.$el;

          if (!dropdown || window.innerWidth <= 991) {
            return;
          }

          const submenus = dropdown.querySelectorAll('.js-header-catalog-submenu');

          submenus.forEach(submenu => {
            submenu.style.removeProperty('--catalog-submenu-sticky-top');
          });

          const activeSubmenu = dropdown.querySelector(
            '.js-header-catalog-content.is-active .js-header-catalog-submenu'
          );

          if (!activeSubmenu) {
            return;
          }

          const dropdownStyle = window.getComputedStyle(dropdown);
          const topGap = parseFloat(dropdownStyle.paddingTop) || 0;
          const bottomGap = parseFloat(dropdownStyle.paddingBottom) || 0;

          const stickyTop = Math.min(
            0,
            dropdown.clientHeight - activeSubmenu.offsetHeight - topGap - bottomGap
          );

          activeSubmenu.style.setProperty(
            '--catalog-submenu-sticky-top',
            stickyTop + 'px'
          );
        },
        splitSubSections(subSections){
          const items = Object.keys(subSections || {}).map(key => subSections[key]);
          const columnSize = Math.ceil(items.length / this.catalogColumnCount);

          return Array.from({length: this.catalogColumnCount}, (_, columnIndex) =>
            items.slice(columnIndex * columnSize, (columnIndex + 1) * columnSize)
          );
        },
        showBrands(button){
          $(button).closest('.js-brands').find('.js-brand').show();
          $(button).hide();

          this.$nextTick(() => {
            this.scheduleCatalogLayout();
          });
        },
        closeSearch2(){
           $(".js-search-input").val('');
          $('.js-search__results').removeClass('is-show');
          $('.js-search-wp').removeClass('is-active');
          $('.js-header-catalog-search').removeClass('is-active');
      }
    },
    template: `
        <div class="header__catalog-dropdown js-catalog-dropdown">
          <a href="#" class="header__catalog-dropdown-close js-catalog-dropdown-close" aria-label="Закрыть меню" @click.prevent="closeMenu()">
            <span class="header__catalog-dropdown-close-stick header__catalog-dropdown-close-stick--first" aria-hidden="true"></span>
            <span class="header__catalog-dropdown-close-stick header__catalog-dropdown-close-stick--second" aria-hidden="true"></span>
          </a>
          <div v-if="this.menu && this.menu.catalog" class="container">
            <div v-for="catalogItem in this.menu.catalog.ITEMS" class="header__catalog-dropdown-wp">
              <div class="header__catalog-dropdown-title">{{catalogItem.TEXT}}</div>
              <div class="header__catalog-dropdown-top">
                <div class="header__catalog-dropdown-btns">
                  <div v-for="(productType, index) in catalogItem.CHILDS"
                    @click="changeTab(index)"
                    class="header__catalog-dropdown-btn js-header-catalog-nav"
                    :class="{'is-active': index === Object.keys(catalogItem.CHILDS)[0]}"
                    :data-nav="index">
                    {{productType.TEXT}}
                  </div>
                </div>
                <div class="header__catalog-dropdown-search js-header-catalog-search">
                  <SearchTrigger variant="mobile" />
                  <div class="header__search-overlay js-header-search-catalog-overlay" @click="closeSearch2();"></div>
                </div>
              </div>
              <div class="header__catalog-dropdown-bottom">

                <div v-for="(productType, index) in catalogItem.CHILDS" class="header__catalog-wp-wp js-header-catalog-content"
                  :class="{'is-active': index === Object.keys(catalogItem.CHILDS)[0]}"
                  :data-nav="index">
                  <div class="header__catalog-wp js-header-catalog-wp">
                    <div class="header__catalog-nav js-tab-nav-wp" @mouseleave="cancelTabSwitch">


                      <div v-for="(section, sectionIndex) in productType.CHILDS" class="header__catalog-nav-item js-header-catalog-nav-item">
                        <div class="header__catalog-nav-item-top">
                          <a :href="section.LINK" class="header__catalog-nav-link js-tab-nav"
                            :class="{'is-active': sectionIndex === Object.keys(productType.CHILDS)[0]}"
                            @mouseenter="tabMouseEnter($event)"
                            :data-tab="sectionIndex">
                            <div v-if="section.PARAMS.ICON !== false" class="header__catalog-nav-link-img">
                              <img class="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="section.PARAMS.ICON" :alt="section.TEXT" :title="section.TEXT">
                              <img v-if="section.PARAMS.ICON_H !== false" class="menu-img-hover lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="section.PARAMS.ICON_H" :alt="section.TEXT" :title="section.TEXT">
                              <img v-else class="menu-img-hover lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="section.PARAMS.ICON" :alt="section.TEXT" :title="section.TEXT">
                            </div>
                            {{section.TEXT}}
                          </a>
                          <div class="header__catalog-nav-arrow js-header-catalog-nav-arrow">
                            <svg class="icon icon-arrow-right-small"><use xlink:href="#icon-arrow-right-small"></use></svg>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div class="header__catalog-submenu js-header-catalog-submenu" @mouseenter="cancelTabSwitch">
                      <div v-for="(section, sectionIndex) in productType.CHILDS"
                        class="header__catalog-content-tab js-tab-content"
                          :class="{'is-active': sectionIndex === Object.keys(productType.CHILDS)[0]}"
                          :data-tab="sectionIndex">
                          <div class="container">
                            <div class="header__catalog-content-tab-wp js-tab-content-wp">
                              <div class="header__catalog-content-dropdown-heading">
                                <a :href="section.LINK" class="header__catalog-content-dropdown-heading-back js-mob-dropdown-back">
                                  <svg class="icon icon-arrow-right-small"><use xlink:href="#icon-arrow-right-small"></use></svg>
                                  {{section.TEXT}}
                                </a>
                              </div>
                              <div class="header__catalog-content-tab-wp-inner">
                                <div class="header__catalog-content-tab-links">
                                  <div v-for="(column, columnIndex) in splitSubSections(section.CHILDS)"
                                    :key="columnIndex"
                                    class="header__catalog-content-tab-links-column">

                                    <a v-for="subSection in column"
                                      :key="subSection.LINK || subSection.TEXT"
                                      :href="subSection.LINK"
                                      class="header__catalog-content-tab-link">
                                      {{subSection.TEXT}}
                                    </a>

                                  </div>
                                </div>

                                <a v-if="section.PARAMS.BANNER_TEXT && section.PARAMS.BANNER_LINK"
                                  :href="section.PARAMS.BANNER_LINK" class="header__catalog-content-tab-new lazy-bg">
                                  <div class="header__catalog-content-tab-new-img">
                                    <img :src="this.SITE_TEMPLATE_PATH + '/img/main/header-news-bg.png'" :alt="section.PARAMS.BANNER_TEXT" :title="section.PARAMS.BANNER_TEXT">
                                  </div>
                                  {{section.PARAMS.BANNER_TEXT}}
                                </a>

                              </div>
                              <div v-if="section.PARAMS.BRANDS && section.PARAMS.BRANDS.length" class="header__catalog-content-tab-brands js-brands">
                                <a v-for="(brand, brandIndex) in section.PARAMS.BRANDS"
                                  :href="section.LINK + brand.FILTER"
                                  class="header__catalog-content-tab-brands-item js-brand"
                                  :class="{'no-photo': brand.FILE === false}"
                                  :style="brandIndex > 6 ? 'display: none;' : ''"
                                  >
                                  <img v-if="brand.FILE !== false" class="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="brand.FILE" :alt="brand.NAME" :title="brand.NAME">
                                  <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="brand.NAME" :title="brand.NAME">
                                </a>
                                <a v-if="section.PARAMS.BRANDS.length > 7" href="#" @click.prevent="showBrands($event.currentTarget)" class="header__catalog-content-tab-brands-item show-all">
                                  Все
                                  <svg class="icon icon-arrow-right-small"><use xlink:href="#icon-arrow-right-small"></use></svg>
                                </a>
                              </div>
                            </div>
                          </div>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
    `
}
